import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'

/**
 * Período de apuração calculado pela API para cada competência.
 * A API atual sempre envia os dois campos; `formatarPeriodo` ainda tolera
 * ausência por causa de cache antigo do React Query.
 */
export interface PeriodoCompetencia {
    dataInicial: string
    dataFinal: string
}

export type AberturaCompetencia = z.infer<
    typeof zod.AberturaCompetenciaSchema
> &
    PeriodoCompetencia
export type FechamentoCompetencia = z.infer<
    typeof zod.FechamentoCompetenciaSchema
> &
    PeriodoCompetencia

const abertura = new ApiService<AberturaCompetencia>(
    'alteracao-competencia/abertura',
)
const fechamento = new ApiService<FechamentoCompetencia>(
    'alteracao-competencia/fechamento',
)

export interface IFechamento {
    data: string
    isNear: boolean
}

const proximoFechamento = new ApiService<IFechamento>(
    'alteracao-competencia/proximo-fechamento',
)

/** @usage softDelete */
export const alteracaoCompetencia = {
    abertura,
    fechamento,
    proximoFechamento,
}
